import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TeamDevelopmentCalendarComponent } from './team-development-calendar.component';
import { TeamDevelopmentCalendarPlayersComponent } from './team-player-list/player-list.component';
import { DevelopmentCalendarPlayerComponent } from './development-calendar-player/development-calendar-player.component';

const routes: Routes = [
  {
    path: '',
    component: TeamDevelopmentCalendarComponent,
    children: [
      { path: 'all-players', component: TeamDevelopmentCalendarPlayersComponent },
      { path: 'player-calendar/:teamID/:playerID', component: DevelopmentCalendarPlayerComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TeamDevelopmentCalendarRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/team-development-calendar/team-development-calendar-routing.module.ts